export default __webpack_public_path__ + "static/media/dog-searching-basket.1f349324.png";